/**
 * Query parameters for multi-resolution signal fetches (#663). All optional;
 * omitting every field yields an empty string so the request keeps the current
 * full-recording behaviour.
 *
 * - `decimated`: target points per channel for a whole-recording overview.
 * - `from`/`to`: sample range for a full-resolution window.
 * - `highPass`/`lowPass`: cutoffs to filter the overview server-side (the
 *   decimated overview cannot be filtered client-side).
 */
export interface SignalQuery {
    decimated?: number;
    from?: number;
    to?: number;
    highPass?: number | null;
    lowPass?: number | null;
}

/** Build the `?…` query string for a signal request, omitting absent fields. */
export function buildSignalQuery(query?: SignalQuery): string {
    if (!query) {
        return '';
    }
    const params = new URLSearchParams();
    if (query.decimated != null) {
        params.set('decimated', String(query.decimated));
    }
    if (query.from != null) {
        params.set('from', String(query.from));
    }
    if (query.to != null) {
        params.set('to', String(query.to));
    }
    if (query.highPass != null) {
        params.set('high_pass', String(query.highPass));
    }
    if (query.lowPass != null) {
        params.set('low_pass', String(query.lowPass));
    }
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}
